/* eslint-disable  */
import moment from 'moment';
import { urls } from '@/Constants';
import {
    timeFilter, timeFilterGeography, timeFilterProduct
} from './config';

export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const MONTH_NAMES_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const getMonthNumber = (monthLabel) => {
    const idx = MONTH_NAMES_SHORT.indexOf(monthLabel);
    return idx === -1 ? null : idx + 1;
};

export const getCurrentDateInfo = () => {
    const todayDate = new Date();
    const currentYear = todayDate.getFullYear();
    const currentMonth = todayDate.getMonth();
    const currentDay = todayDate.getDate();
    const currentHour = todayDate.getHours();
    return {
        year: currentYear,
        month: currentMonth + 1,
        day: currentDay,
        hour: currentHour,
    };
};
export const getQuickPickerRanges = () => {
    const now = new Date();
    const today = new Date(now);
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDayOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    const firstDayOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const firstDayOfYear = new Date(now.getFullYear(), 0, 1);
    const firstDayOfLastYear = new Date(now.getFullYear() - 1, 0, 1);
    const lastDayOfLastYear = new Date(now.getFullYear() - 1, 11, 31);

    return [
        {
            label: 'Last 7 days', value: [new Date(today.setDate(today.getDate() - 7)), new Date()],
        },
        {
            label: 'Last 30 days', value: [new Date(today.setDate(today.getDate() - 30)), new Date()],
        },
        {
            label: 'This month', value: [firstDayOfMonth, new Date()],
        },
        {
            label: 'Last month', value: [firstDayOfLastMonth, lastDayOfLastMonth],
        },
        {
            label: 'Last 3 months', value: [new Date(now.setMonth(now.getMonth() - 3)), new Date()],
        },
        {
            label: 'Last 6 months', value: [new Date(now.setMonth(now.getMonth() - 6)), new Date()],
        },
        {
            label: 'This year', value: [firstDayOfYear, new Date()],
        },
        {
            label: 'Last year', value: [firstDayOfLastYear, lastDayOfLastYear],
        },
    ];
};

export const quickPickerRanges = getQuickPickerRanges();

export const formatDate = (date) => {
    if (!date) return '';
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear().toString().slice(2);
    let daySuffix = 'th';
    if (day % 10 === 1 && day !== 11) daySuffix = 'st';
    else if (day % 10 === 2 && day !== 12) daySuffix = 'nd';
    else if (day % 10 === 3 && day !== 13) daySuffix = 'rd';
    return `${day}${daySuffix} ${month}'${year}`;
};

export const getDayWithSuffix = (date) => {
    const d = date?.getDate();
    if (d > 3 && d < 21) return `${d}th`;
    switch (d % 10) {
        case 1: return `${d}st`;
        case 2: return `${d}nd`;
        case 3: return `${d}rd`;
        default: return `${d}th`;
    }
};

export const TAB_BUTTON_BASE = 'px-5 py-2 text-sm font-medium rounded-lg transition-all duration-150';
export const TAB_BUTTON_ACTIVE = 'bg-yellow-300 text-black';
export const TAB_BUTTON_INACTIVE = 'bg-[#F3F4F6] text-slate-600 hover:bg-slate-200/60';

export const deserializer = (state, filters, hideFilter = true) => {
    const { year, month } = getCurrentDateInfo();
    if (hideFilter) {
        return {
            dateFilter: state?.dateFilter,
            grouping: { ...state?.grouping, type: state?.selectedTab },
            dateRangeFilter: {},
            ...(state?.selectedTab !== 'periodWise' && { dateRangeFilter: { from: moment(state?.dateRangeObj?.from).format('YYYY-MM-DD'), to: moment(state?.dateRangeObj?.to).format('YYYY-MM-DD') } }),
            analysisType: "BOM",
            showInternalData: false,
            yAxis: state?.selectedChartTab,
            perUnit: state?.perUnitToggle,
            variantIds: state?.filters?.product?.id ? [state?.filters?.product?.id] : [],
            shiftId: state?.filters?.type ? state?.filters?.type : null,
            storeFilter: state?.filters?.store?.id ? [state?.filters?.store?.id] : [],
        };
    }
    return {
        dateFilter: {
            year,
            month,
            day: null,
            hour: null,
            currentSelection: 'month',
        },
        grouping: {
            active: true,
            type: 'periodWise',
            currentSelection: null,
            selection: {},
        },
        storeFilter: filters?.storeId,
        dateRangeFilter: filters?.dateRange,
    };
};

export const getTimeFilterListForTab = (tab, brandsData, selectedYear, selectedMonth, value, timeFilterList) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    if (tab === 'periodWise') {
        return timeFilter.map(item => {
            const newItem = { ...item };
            if (item.value === 'year') {
                newItem.label = selectedYear || currentYear.toString();
            } else if (item.value === 'month') {
                const monthIndex = selectedMonth ? selectedMonth - 1 : currentMonth;
                newItem.label = MONTH_NAMES_SHORT[monthIndex];
            } else if (item.value === 'day') {
                newItem.label = getDayWithSuffix(today);
            }
            return newItem;
        });
    } else if (tab === 'productGroupWise') {
        return timeFilterProduct.map(item => {
            const newItem = { ...item };
            if (item.value === 'brand') {
                newItem.label = brandsData?.[0]?.name || 'Brand';
            }
            return newItem;
        });
    } else if (tab === 'geographyWise') {
        const indexValue = timeFilterGeography?.findIndex(item => item.value === value);
        return timeFilterGeography.map((item, index) => {
            if (index <= indexValue) {
                const existing = timeFilterList?.find(t => t.value === item.value);
                return existing ? { ...existing } : { ...item };
            }
            return { ...item };
        });
    }
    return [];
};

export const handleTimeFilterClick = (filterValue, selectedTab, setSelectedTimeFilter, setDateFilter, setGrouping, selectedYear, selectedMonth, grouping) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    setSelectedTimeFilter(filterValue);
    if (selectedTab === 'periodWise') {
        if (filterValue === 'year') {
            setDateFilter({
                year: selectedYear ?? currentYear,
                month: null,
                day: null,
                hour: null,
                week: null,
                currentSelection: 'year',
            });
        } else if (filterValue === 'month') {
            setDateFilter({
                year: selectedYear ?? currentYear,
                month: selectedMonth ?? (currentMonth + 1),
                day: null,
                hour: null,
                week: null,
                currentSelection: 'month',
            });
        } else if (filterValue === 'day') {
            // Use the selected month if available, otherwise use current month
            const monthToUse = selectedMonth ?? (currentMonth + 1);
            setDateFilter({
                year: selectedYear ?? currentYear,
                month: monthToUse,
                day: today.getDate(),
                hour: null,
                week: null,
                currentSelection: 'day',
            });
        }
    } else if (selectedTab === 'geographyWise') {
        if (filterValue === 'store') {
            setGrouping({
                active: true,
                type: 'geographyWiseNew',
                currentSelection: 'kitchen',
                selection: {},
            });
        } else if (filterValue === 'section') {
            setGrouping({
                active: true,
                type: 'geographyWiseNew',
                currentSelection: 'section',
                selection: {
                    store: grouping?.selection?.store,
                },
            });
        } else if (filterValue === 'process') {
            setGrouping({
                active: true,
                type: 'geographyWiseNew',
                currentSelection: 'process',
                selection: {
                    store: grouping?.selection?.store,
                    section: grouping?.selection?.section,
                },
            });
        }
    } else {
        setGrouping({
            active: true,
            type: selectedTab,
            currentSelection: filterValue,
            selection: {},
        });
    }
};

export const timeChartClick = (selectedTimeFilter, params, timeFilterList, setTimeFilterList, setDateFilter, setSelectedTimeFilter, selectedYear, setFilters = null, filters = {}) => {
    const today = new Date();
    const currentYear = selectedYear ?? today.getFullYear();
    const base = {
        year: null,
        month: null,
        day: null,
        hour: null,
        week: null,
        currentSelection: null,
    };
    if (selectedTimeFilter === 'year') {
        const clickedMonth = params?.name;
        const monthNum = getMonthNumber(clickedMonth);

        setTimeFilterList((prev) => [
            { value: 'year', label: currentYear.toString() },
            { value: 'month', label: clickedMonth },
            {
                value: 'day',
                label: 'Day',
                tagList: prev.find((item) => item.value === 'day')?.tagList,
            },
        ]);

        setDateFilter({
            ...base,
            year: currentYear,
            month: monthNum,
            currentSelection: 'month',
        });
        setTimeout(() => {
            setSelectedTimeFilter('month');
        }, 0);
        // Clear timeTypeFilter when not on day
        if (setFilters) {
            setFilters({
                ...filters,
                timeTypeFilter: null,
            });
        }

    } else if (selectedTimeFilter === 'month') {

        const clickedDay = params?.name;
        const dayNum = parseInt(clickedDay.toString().replace(/\D/g, ''));

        const currentDateFilter = timeFilterList.find((item) => item.value === 'month');
        const selectedMonth = getMonthNumber(currentDateFilter?.label);
        const selectedMonthName = currentDateFilter?.label;

        setTimeFilterList((prev) => [
            { value: 'year', label: currentYear.toString() },
            { value: 'month', label: selectedMonthName },
            {
                value: 'day',
                label: getDayWithSuffix(
                    new Date(currentYear, selectedMonth - 1, dayNum)
                ),
                tagList: prev.find((item) => item.value === 'day')?.tagList,
            },
        ]);

        setDateFilter({
            ...base,
            year: currentYear,
            month: selectedMonth,
            day: dayNum,
            currentSelection: 'day',
        });

        setTimeout(() => {
            setSelectedTimeFilter('day');
        }, 0);
        // Set timeTypeFilter to PerHour when drilling down to day
        if (setFilters) {
            setFilters({
                ...filters,
                timeTypeFilter: 'PerHour',
            });
        }
    } else if (selectedTimeFilter === 'day') {
        window.open(`${urls.EXTENSION}${urls.PRODUCTION_LIST}?hide=true`, '_blank');
    }
};

export const productChartClick = (selectedTimeFilter, params, grouping, selectedTab, setTimeFilterList, setGrouping, setSelectedTimeFilter, chartData, isShowModal, openModal) => {
    if (selectedTimeFilter === 'brand') {
        const clickedCategory = params?.name;
        setTimeFilterList((prev) => {
            const newList = [...prev];
            const index = newList.findIndex((item) => item.value === 'category');
            newList[index] = {
                ...newList[index],
                label: clickedCategory,
            };
            return newList;
        });
        setSelectedTimeFilter('category');
        setGrouping({
            ...grouping,
            type: selectedTab,
            currentSelection: 'category',
            selection: {
                category: chartData?.labelIds?.[params?.dataIndex],
                subCategory: null,
            },
        });
    } else if (selectedTimeFilter === 'category') {
        const clickedSubCategory = params?.name;
        setTimeFilterList((prev) => {
            const newList = [...prev];
            const index = newList.findIndex((item) => item.value === 'subCategory');
            newList[index] = {
                ...newList[index],
                label: clickedSubCategory,
            };
            return newList;
        });
        setSelectedTimeFilter('subCategory');
        setGrouping({
            ...grouping,
            type: selectedTab,
            currentSelection: 'subCategory',
            selection: {
                category: grouping?.selection?.category,
                subCategory: chartData?.labelIds?.[params?.dataIndex],
            },
        });
    }
    else if (selectedTimeFilter === 'subCategory') {
        if (isShowModal) {
            openModal(chartData?.labelIds?.[params?.dataIndex], params?.name);
            return;
        }
        window.open(`${urls.EXTENSION}${urls.PRODUCTION_LIST}?hide=true`, '_blank');
    }

};

export const geographyChartClick = (selectedTimeFilter, params, grouping, selectedTab, setTimeFilterList, setGrouping, setSelectedTimeFilter, chartData, isShowModal, openModal) => {
    if (selectedTimeFilter === 'store') {
        const clickedStore = params?.name;
        setTimeFilterList((prev) => {
            const newList = [...prev];
            const index = newList.findIndex((item) => item.value === 'section');
            if (index !== -1) {
                newList[index] = {
                    ...newList[index],
                    label: clickedStore,
                };
            }
            return newList;
        });
        setSelectedTimeFilter('section');
        setGrouping({
            ...grouping,
            type: 'geographyWiseNew',
            currentSelection: 'store',
            selection: {
                store: chartData?.labelIds?.[params?.dataIndex],
                section: null,
            },
        });
    } else if (selectedTimeFilter === 'section') {
        const clickedSection = params?.name;
        setTimeFilterList((prev) => {
            const newList = [...prev];
            const index = newList.findIndex((item) => item.value === 'process');
            if (index !== -1) {
                newList[index] = {
                    ...newList[index],
                    label: clickedSection,
                };
            }
            return newList;
        });
        setSelectedTimeFilter('process');
        setGrouping({
            ...grouping,
            type: 'geographyWiseNew',
            currentSelection: 'section',
            selection: {
                store: grouping?.selection?.store,
                section: chartData?.labelIds?.[params?.dataIndex],
            },
        });
    }
    else if (selectedTimeFilter === 'process') {
        if (isShowModal) {
            openModal(chartData?.labelIds?.[params?.dataIndex], params?.name, 'process');
            return;
        }
        // window.open(`${urls.EXTENSION}${urls.PRODUCTION_LIST}?hide=true`, '_blank');
        // Or handle process click if needed, currently no further drill down
    }
};

export const yearOptions = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= currentYear - 1; year--) {
        years.push({ label: year.toString(), value: year });
    }
    return years;
}